/**
 * Video tutorials surfaced by the home-page "Tutorials available" badge.
 * Set `actionId` to also point a callout at that module action; several tutorials
 * may share an action. Add new entries here.
 */
export const TUTORIALS = [
  {
    id: "brokerDashOperations",
    title: "Broker Dashboard Operations in Admin",
    youtubeId: "JP51WTq1970",
    url: "https://youtu.be/JP51WTq1970",
    actionId: "brokerDashOperations",
  },
  {
    id: "sheetTemplates",
    title: "Sheet Templates in Admin",
    youtubeId: "7WabElF8F9I",
    url: "https://youtu.be/7WabElF8F9I",
    actionId: "sheetsTemplates",
  },
  {
    id: "sheetTemplateRunPolling",
    title: "Sheet Template Run — Polling and Execution Endpoints",
    youtubeId: "rPAZObL1gko",
    url: "https://youtu.be/rPAZObL1gko",
    actionId: "sheetsTemplates",
  },
];

/**
 * Embed URL that starts playing as soon as the player opens. Uses the standard
 * youtube.com player (the nocookie domain tends to trigger "sign in to confirm
 * you're not a bot") and passes `origin` so YouTube can verify the embedding site.
 */
export function tutorialEmbedUrl(tutorial) {
  const params = new URLSearchParams({ autoplay: "1", rel: "0", playsinline: "1" });
  if (typeof window !== "undefined" && window.location?.origin) {
    params.set("origin", window.location.origin);
  }
  return `https://www.youtube.com/embed/${tutorial.youtubeId}?${params.toString()}`;
}

export function getTutorialsForAction(actionId) {
  return TUTORIALS.filter((t) => t.actionId === actionId);
}

/**
 * API doc callouts shown beside a module action, like tutorial callouts.
 * Clicking opens `targetAction` scrolled to the `anchor` element id. Add new entries here.
 */
export const DOC_LINKS = [
  {
    id: "sheetTemplateRunApi",
    title: "Sheet Template Run API",
    label: "Run API docs",
    actionId: "sheetsTemplates",
    targetAction: "munshotDataApiDocs",
    anchor: "sheet_template_run",
  },
];

export function getDocLinkForAction(actionId) {
  return DOC_LINKS.find((d) => d.actionId === actionId) || null;
}
